"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicApiName = void 0;
var PublicApiName;
(function (PublicApiName) {
    PublicApiName["ClientAccounts"] = "clientAccounts";
    PublicApiName["ClientAccountByKey"] = "clientAccountByKey";
    PublicApiName["ClientAccountDocuments"] = "clientAccountDocuments";
    PublicApiName["Portfolios"] = "portfolios";
    PublicApiName["PortfolioByKey"] = "portfolioByKey";
    PublicApiName["PortfolioTransactions"] = "portfolioTransactions";
    PublicApiName["PortfolioPerformance"] = "portfolioPerformance";
    PublicApiName["PortfolioHoldings"] = "portfolioHolding";
    PublicApiName["PortfolioAssetClasses"] = "portfolioAssetClasses";
    PublicApiName["Advisers"] = "advisers";
    PublicApiName["Contacts"] = "contacs";
    PublicApiName["Moneysoft"] = "moneysoftFinancialDetails";
    PublicApiName["SuperSimplifierAccounts"] = "supersimplifierAccounts";
    PublicApiName["SuperSimplifierAccount"] = "supersimplifierAccount";
    PublicApiName["SuperSimplifierContributions"] = "supersimplifierContributions";
    PublicApiName["SuperSimplifierDocuments"] = "supersimplifierDocuments";
})(PublicApiName = exports.PublicApiName || (exports.PublicApiName = {}));
